import styled from 'styled-components';

/**
 * A `Tabs.Panels` component is the parent of a set of `Tabs.Panel` components
 * and a child of a `Tabs` component.
 *
 * @since 8.10.0
 */
var TabPanels = /*#__PURE__*/styled.div.withConfig({
  displayName: "TabPanels",
  componentId: "c11n-8-101-0__sc-v8ly7k-0"
})([""]);
TabPanels.displayName = 'Tabs.Panels';

/** @component */
export { TabPanels };